





































































































































import { Component, Watch, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import {
  getCateList,
  getInstallList,
  installsSend,
  installsDel,
  getInstallResourceListByClient
} from '@/api/admin'
import conFirm from './confirm.vue'
import router from '../../router'
import Filters from '@/components/filteradmin'
@Component({
  components: {
    conFirm,
    Filters
  }
})
export default class Install extends ViewBase {
  @Prop({ type: Number, default: 0 }) id!: number
  loading = true
  type = 20
  errMsg = ''
  total = 0
  page = 1
  pageSize = 10
  list = null
  editItem = {}
  delItem = {}
  editVisible = false
  delVisible = false
  title = ''
  resType = ''
  resTypeList = []
  needStatus = ''
  phaseList = []
  subjectList = []
  dresType = {}
  dphase = {}
  dsubject = {}
  pagination: any = {}
  columns: any = []
  searchkey = ''
  lang = {}
  expandedRowKeys: any = []
  selectedRowKeys: any = []
  doc: any
  visible1 = false
  visible2 = false
  installid = []
  allDeviceIds = []
  statusList: any = [
    { id: 3, name: '已安装' }, // 提供卸载和批量卸载操作
    { id: 4, name: '未安装' }, // 提供安装和批量安装操作；
    { id: 1, name: '安装中' }, // 提供安装和批量安装操作，但按钮置灰不可用
    { id: 2, name: '安装失败' } // 提供安装和批量安装操作；
  ]

  status = 3
  defaultQuery: any = {
    page: 1,
    pageSize: 20,
    cid: this.id,
    status: this.status
  }

  get i18n() {
    const value = this.$t('login')
    return value as any
  }
  query: any = Object.assign({}, this.defaultQuery)
  created() {
    this.doc = window.document
    this.lang = this.i18n.vInstall
    const lang: any = this.lang
    this.statusList = [
      { id: 3, name: lang.installed }, // 提供卸载和批量卸载操作
      { id: 4, name: lang.uninstall }, // 提供安装和批量安装操作；
      { id: 1, name: lang.installing }, // 提供安装和批量安装操作，但按钮置灰不可用
      { id: 2, name: lang.installFail } // 提供安装和批量安装操作；
    ]

    this.columns = [
      {
        title: '',
        dataIndex: 'cover',
        className: 'texcenter width80',
        scopedSlots: { customRender: 'image' }
      },
      {
        title: lang.name,
        className: 'colName',
        dataIndex: 'title'
      },
      // {
      //   title: lang.type,
      //   className: 'colNickname',
      //   dataIndex: 'res_type',
      //   scopedSlots: { customRender: 'res_type' }
      // },
      // {
      //   title: lang.phaseOfStudy,
      //   dataIndex: 'phase_ids',
      //   scopedSlots: { customRender: 'phaseOfStudy' }
      //   // className:css.colnum,
      // },
      // {
      //   title: lang.installed,
      //   className: 'colnum',
      //   dataIndex: 'doneCount'
      // },
      // {
      //   title: lang.installing,
      //   className: 'colnum',
      //   dataIndex: 'beingCount'
      // },
      // {
      //   title: lang.installFail,
      //   className: 'colnum',
      //   dataIndex: 'failCount'
      // },
      // {
      //   title: lang.uninstall,
      //   className: 'colnum',
      //   dataIndex: 'pendCount'
      // },
      {
        title: lang.operation,
        dataIndex: 'operation',
        className: 'texcenter width120',
        scopedSlots: { customRender: 'operation' }
      }
    ]
    this.getType()
  }
  async getType() {
    try {
      const { data } = await getCateList()
      // console.log('获取学科接口', data)
      const resTypeList: any = []
      const dsubject: any = []
      const phaseList: any = []
      const dphase: any = []
      const dresType: any = []

      data.res_type.map((item: any) => {
        dresType[item.id] = item.name
        resTypeList.push(item)
      })
      data.phase.map((item: any) => {
        dphase[item.id] = item.name
        phaseList.push(item)
        item.subject.map((subject: any) => {
          dsubject[subject.id] = subject.name
        })
      })

      this.resTypeList = resTypeList
      this.dsubject = dsubject
      this.dphase = dphase
      this.dresType = dresType
      this.phaseList = phaseList
      this.fetch({
        cid: this.id,
        status: this.status,
        page: 1,
        res_type: 0,
        // phase_id: '0',
        // subject_id: '0',
        keyword: ''
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }

  setQuery(val: object) {
    // console.log(val)
    this.query = Object.assign({}, this.defaultQuery, val)
    this.query.page = 1 // 筛选器变化重置页码
    //  console.log(this.query)
    this.fetch()
    // query存到store
    // this.$store.commit('setSearchQuery', this.query)
  }

  changegeres_type(dd: any) {
    // console.log(dd)
    this.resType = dd
    this.fetch({
      page: 1,
      res_type: this.resType,
      phase: 0,
      subject: 0,
      key: this.searchkey
    })
  }
  change_status(dd: any) {
    // console.log(dd)
    this.status = dd
    this.defaultQuery = Object.assign({}, this.defaultQuery, {status: dd})
    this.query = Object.assign({}, this.query, {status: dd})
    // this.fetch({
    //   page: 1,
    //   status: this.status,
    //   res_type: this.resType,
    //   phase: 0,
    //   subject: 0,
    //   key: this.searchkey
    // })
  }
  searcha(val: any) {
    // console.log(val)
    this.searchkey = val
    this.fetch({
      page: 1,
      res_type: this.resType,
      phase: 0,
      subject: 0,
      key: this.searchkey
    })
  }
  handleTableChange(pagination: any) {
    // console.log(pagination)
    const pager: any = { ...this.pagination }
    pager.current = pagination.current
    this.pagination = pager
    this.query.page = pagination.current

    this.fetch()
  }

  async fetch(params: any = {}) {
    // console.log('params:', params)
    this.loading = true
    const query = JSON.parse(JSON.stringify(this.query))
    try {
      const { data } = await getInstallResourceListByClient(query)

      const pagination: any = { ...this.pagination }
      // Read total count from server
      // pagination.total = data.totalCount;
      pagination.total = data.total
      this.loading = false
      this.list = data.list
      this.pagination = pagination

      const rids: any = data.list
      const allDeviceIds: any = []
      if (rids) {
        rids.map((item: any) => {
          allDeviceIds.push(item.rid)
        })
      }
      this.allDeviceIds = allDeviceIds
    } catch (ex) {
      this.handleError(ex)
    }
  }
  back(dd: any) {
    // console.log(dd)
    if (dd == 0) {
    } else {
      this.$router.push({
        name: 'installdev',
        query: { page: '0' }
      })
    }
  }
  onSelectChange(selectedRowKeys: any) {
    // console.log('selectedRowKeys changed: ', selectedRowKeys)
    this.selectedRowKeys = selectedRowKeys
  }
  info(item: any) {
    let dd = []
    dd.push(item.id)
    if (this.expandedRowKeys[0] == item.id) {
      dd = []
    }
    this.expandedRowKeys = dd
  }
  // 各种展示提交操作
  cancelMod() {
    this.visible1 = false
    this.visible2 = false
  }

  oninstallshow(item: any) {
    const id: any = []
    id.push(item.rid)
    this.visible1 = true
    this.installid = id
  }
  uninstallshow(item: any) {
    const id: any = []
    id.push(item.rid)
    this.visible2 = true
    this.installid = id
  }
  allupdateshow() {
    const id: any = Object.assign([], this.selectedRowKeys)
    // console.log(this.selectedRowKeys)
    if (this.selectedRowKeys.length <= 0) {
      this.$message.error(this.i18n.vInstall.plasechose)
    } else {
      this.visible1 = true
      this.installid = id
    }
  }
  alluninstallshow() {
    const id: any = Object.assign([], this.selectedRowKeys)
    // console.log(this.selectedRowKeys)
    if (this.selectedRowKeys.length <= 0) {
      this.$message.error(this.i18n.vInstall.plasechose)
    } else {
      this.visible2 = true
      this.installid = id
    }
  }
  async oninstall() {
    const pdata: any = {
      rids: this.installid,
      ids: this.id
    }
    try {
      const res = await installsSend(pdata)
      this.$message.success(this.i18n.vAccountForm.operationSuccess)
      this.visible1 = false
      this.selectedRowKeys = []
      this.fetch({
        page: this.pagination.current || 1,
        res_type: this.resType,
        phase: 0,
        subject: 0,
        key: this.searchkey
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }
  async uninstall() {
    const pdata: any = {
      rids: this.installid,
      ids: this.id
    }
    try {
      const res = await installsDel(pdata)
      this.$message.success(this.i18n.vAccountForm.operationSuccess)
      this.visible2 = false
      this.selectedRowKeys = []
      this.fetch({
        page: this.pagination.current || 1,
        res_type: this.resType,
        phase: 0,
        subject: 0,
        key: this.searchkey
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }

  @Watch('query', { deep: true })
  watchQuery() {
    this.fetch()
  }
}
